<template>
  <div class="input-wrapper">
    <input type="text" v-model="model" class="input-text" v-bind="$attrs">
    <span class="error" v-if="props.showError">Error</span>
  </div>
</template>

<script setup>
import { defineProps, computed, defineEmit } from 'vue'

const props = defineProps({
  showError: {
    type: Boolean,
    default: false
  },
  modelValue: {
    type: String,
    default: ''
  }
})

const emit = defineEmit(['update:modelValue'])

const model = computed({
  get: () => props.modelValue,
  set: (v) => {
    emit('update:modelValue', v)
  }
})

</script>

<style lang="scss" scoped>
.input-wrapper {
  display: flex;
  flex-direction: column;
  gap: .3rem;

  input {
    padding: 12px;
    border: 1px solid $blue-accent;
    border-radius: 5px;
    outline: none;

    &:invalid {

      &:focus {

        border: #C62127 2px solid;
      }
    }

  }

  .error {
    font-weight: 400;
    font-size: 12px;
    line-height: 150%;
    /* identical to box height, or 18px */

    /* Secondary/Red */

    color: #C62127;
  }
}
</style>
